import React from 'react';
import {reactCreateMemo} from '@wix/devzai-utils-react';
import {
    DoppeActionLayout,
    DoppeActionLayoutMediaRatio,
    doppeActionLayoutMediaRatioResolveWidthHeightRatio,
    DoppeActionLayoutMediaSize,
    doppeHideableValueIsVisibleAndNotEqualValue,
    DoppeListActionSettings
} from '../../../../client-server-common';
import {IDoppeViewerActionContext} from '../../../../doppe-sdk';
import {DoppeActionTypeMediaGallery} from '../../../doppe-action-type-media-gallery/doppe-action-type-media-gallery';
import {
    DoppeActionTypeCommonListViewItem
} from '../doppe-action-type-common-list-view-item/doppe-action-type-common-list-view-item';

export const DoppeActionTypeGalleryListViewItem = reactCreateMemo(function DoppeActionTypeGalleryListViewItem<PROPS extends DoppeListActionSettings.WithItemClickBehaviour>(
    props: {
        mediaSize: DoppeActionLayoutMediaSize | null;
        listItemSettings: DoppeActionTypeMediaGallery.MediaGalleryListItemSettings;
        layout: DoppeActionLayout;
        isOneItem: boolean;
        hideTitleWhenPossible?: boolean;
        hideDescriptionWhenPossible?: boolean;
        actionContext?: IDoppeViewerActionContext<PROPS>;
        innerItemIndex: number;
        innerItemId: string;
        mediaRatio?: DoppeActionLayoutMediaRatio;
    }
) {
    const {
        listItemSettings,
        mediaSize,
        layout,
        mediaRatio,
        isOneItem = false,
        hideTitleWhenPossible = false,
        hideDescriptionWhenPossible = false,
        actionContext,
        innerItemIndex,
        innerItemId,
    } = props;

    const {
        ribbon,
        description,
        title,
        media,
    } = listItemSettings;

    const gridImageRatio = mediaRatio ? doppeActionLayoutMediaRatioResolveWidthHeightRatio(mediaRatio) : undefined;

    switch (layout) {
        case DoppeActionLayout.Column:
        case DoppeActionLayout.ImagesGrid:
        case DoppeActionLayout.Grid:
        case DoppeActionLayout.CarouselSmall:
        case DoppeActionLayout.LargeColumn:
        case DoppeActionLayout.Swiper:
        case DoppeActionLayout.Carousel: {
            return <DoppeActionTypeCommonListViewItem
                mediaSize={mediaSize}
                actionContext={actionContext}
                innerItemId={innerItemId}
                innerItemIndex={innerItemIndex}
                title={title}
                description={doppeHideableValueIsVisibleAndNotEqualValue(description, '') ? description : ''}
                image={media}
                layout={layout}
                gridImageRatio={gridImageRatio}
                ribbon={doppeHideableValueIsVisibleAndNotEqualValue(ribbon, '') ? ribbon : undefined}
                isOneItem={isOneItem}
                hideImageWhenPossible={false}
                hideTitleWhenPossible={hideTitleWhenPossible}
                hideDescriptionWhenPossible={hideDescriptionWhenPossible}
            />;
        }
    }
});



